import * as React from 'react'

const SvgR2D2 = (props) => {
  const { color } = props
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0h48v48H0z' />
        <path
          fill={color || '#FFF'}
          fillRule='nonzero'
          d='M9.312 14.304v26.784h5.856V14.304H9.312Zm4.512 25.536H10.56V15.552h3.264V39.84Zm19.104-25.536v26.784h5.856V14.304h-5.856Zm4.608 25.536h-3.264V15.552h3.264V39.84Z'
        />
        <path
          fill={color || '#FFF'}
          fillRule='nonzero'
          d='M24.096 7.392c-.768 0-1.344.576-1.344 1.344 0 .768.576 1.344 1.344 1.344.768 0 1.344-.576 1.344-1.344 0-.768-.672-1.344-1.344-1.344m0 4.416c-1.728 0-3.072-1.344-3.072-3.072s1.344-3.072 3.072-3.072 3.072 1.344 3.072 3.072-1.44 3.072-3.072 3.072Zm5.856-.192c0 .576-.48 1.056-1.056 1.056-.576 0-1.056-.48-1.056-1.056 0-.576.48-1.056 1.056-1.056.576-.096 1.056.384 1.056 1.056Zm-10.944 27.36h10.08l1.536-3.264H17.472l1.536 3.264Zm10.848 1.248H18.24l-2.784-5.856h17.28l-2.88 5.856Zm3.168 6.528h5.664l.864-1.056-1.824-4.512H34.08l-1.824 4.512.768 1.056ZM39.36 48h-6.912l-1.728-2.112 2.496-6.048h5.472l2.496 6.048L39.36 48ZM9.408 46.752h5.664l.864-1.056-1.824-4.512h-3.744l-1.824 4.512.864 1.056ZM15.648 48H8.736l-1.728-2.112 2.496-6.048h5.472l2.496 6.048L15.648 48Zm-.48-13.536h17.856V11.808c0-2.4-.96-4.704-2.688-6.336l-.288-.288.672-2.112-1.536-.96-1.824 1.536-.48-.192c-.96-.288-1.92-.48-2.88-.48-4.896 0-8.928 3.936-8.928 8.832v22.656h.096Zm19.104 1.248H13.824V11.808C13.824 6.24 18.432 1.632 24 1.632c.96 0 2.016.096 2.976.384L28.992.384 32.064 2.4l-.672 2.4c1.824 1.92 2.88 4.32 2.88 7.008v23.904ZM19.104 21.408h10.368V19.68H19.104v1.728Zm0-2.976h10.368v-1.728H19.104v1.728Zm-4.128-2.976H33.12v-1.344H14.976v1.344Z'
        />
      </g>
    </svg>
  )
}

export default SvgR2D2
